import React from 'react';
import { useUser } from '../../hooks/use-user';
import { Box, Select, Text } from '../../ui';

type SelectPickerProps = {
  label: string;
  selected: string;
  values: Array<{
    value: string;
    label: string;
  }>;
  onSelect: (arg0: string) => void;
};

const SelectPicker = ({
  label,
  selected,
  values,
  onSelect,
}: SelectPickerProps) => {
  const user = useUser();

  if (!user) {
    return null;
  }

  // TODO: this should use customizationInfo isLegacy but am just doing this
  // since all SelectPickers are legacy for now.
  if (user && !user.isLegacyUser) {
    return null;
  }

  return (
    <Box
      pt={3}
      sx={{
        'svg path': {
          fill: 'white',
        },
      }}
    >
      <Text variant="listHeadingDark" py={1}>
        {label}
      </Text>
      <Select
        variant="selectDark"
        value={selected}
        onChange={(e) => onSelect(e.target.value)}
      >
        {values.map((value) => {
          return <option value={value.value}>{value.label}</option>;
        })}
      </Select>
    </Box>
  );
};

export default SelectPicker;
